module.exports = __webpack_public_path__ + "static/media/icon-wrong.001b685f.svg";